<template>
    <div class="stats-container">

      <a href="http://www.msobcfdc.org/" class="link-anchor">
                                    Click here to go back on <span class="link">www.msobcfdc.org</span>
                                    </a>
        <div class="stats-main-wrap">
          
            <img src="../../assets/images/registrations.png" class="header-icon"/>
            <!-- <h4 class="stats-heading">Total Registrations</h4> -->
          
          <div class="row stat-box-row no-gutters">
            
            <div class="col">
              <div class="stat-box-wrap">
                <div class="icon-box">
                  <img src="../../assets/images/profile.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Total Registrations</h6>
                  <h5 class="number">{{loanData.totalProfile}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            <div class="col">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#ff5721;">
                  <img src="../../assets/images/application.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Total Applications</h6>
                  <h5 class="number">{{loanData.totalApp}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            <div class="col">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#009789;">
                  <img src="../../assets/images/group.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Total LOI Generated</h6>
                  <h5 class="number">{{loanData.totalLoi}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            <div class="col">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#e91d62">
                  <img src="../../assets/images/pending.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Total LOI Amount</h6>
                  <h5 class="number">{{loanData.totalAmt}} Cr.</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
          </div> <!-- row -->
        </div> <!-- stat-main-wrap -->


        <!-- =========================== -->
      <div class="row no-gutters row-2 stats-boxes-2">

        <div class="stats-main-wrap col col-lg-6" style="text-align:center">

          <img src="../../assets/images/sanctioned.png" class="header-icon"/>
          
            <h4 class="stats-heading">Individual Loan Scheme</h4>
          
          <div class="row stat-box-row no-gutters">
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#ff5721;">
                  <img src="../../assets/images/application.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">No. of Applications</h6>
                  <h5 class="number">{{loanData.indApp}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
            
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#e91d62">
                  <img src="../../assets/images/number.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">No. of LOI Generated</h6>
                  <h5 class="number">{{loanData.personalLoi}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->

            <div class="col col-lg-3">
            </div>
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#009789;">
                  <img src="../../assets/images/value.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Amt. of Generated LOI</h6>
                  <h5 class="number">{{loanData.personalLoiAmt}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->

          </div> <!-- row -->
        </div> <!-- stat-main-wrap -->



        <!-- ==================== -->

        <div class="stats-main-wrap col col-lg-6">

          <img src="../../assets/images/sanctioned.png" class="header-icon"/>
          
          <h4 class="stats-heading">Group Loan Scheme</h4>
          
          <div class="row stat-box-row no-gutters">
             <div class="col">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#009789;">
                  <img src="../../assets/images/group.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">No. of Applications</h6>
                  <h5 class="number">{{loanData.groupApp}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
            
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#ff5721;">
                  <img src="../../assets/images/number.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">No. Of LOI Generated</h6>
                  <h5 class="number">{{loanData.groupLoi}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
            <div class="col col-lg-3">
            </div>
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#00bcd4;;">
                  <img src="../../assets/images/value.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Amt. of Generated LOI</h6>
                  <h5 class="number">{{loanData.groupLoiAmt}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            


           
          </div> <!-- row -->
        </div> <!-- stat-main-wrap -->


        <!-- =========Education Loan=========== -->

        <div class="stats-main-wrap col col-lg-6" style="margin:0px auto !important">

          <img src="../../assets/images/sanctioned.png" class="header-icon"/>
          
          <h4 class="stats-heading">Education Loan Scheme</h4>
          
          <div class="row stat-box-row no-gutters">
             <div class="col">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#009789;">
                  <img src="../../assets/images/group.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">No. of Applications</h6>
                  <h5 class="number">{{loanData.EducationApp}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
            
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#ff5721;">
                  <img src="../../assets/images/number.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">No. Of LOI Generated</h6>
                  <h5 class="number">{{loanData.EducationLoi}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
            <div class="col col-lg-3">
            </div>
            <div class="col col-lg-6">
              <div class="stat-box-wrap">
                <div class="icon-box" style="background:#00bcd4;;">
                  <img src="../../assets/images/value.png" />
                </div> <!-- icon-box ends -->

                <div class="info-box">
                  <h6 class="info-text">Amt. of Generated LOI</h6>
                  <h5 class="number">{{loanData.EducationLoiAmt}}</h5>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            


           
          </div> <!-- row -->
        </div> <!-- stat-main-wrap -->
        

      </div>

        
    </div> <!-- stats-container -->
</template>

<script>
import apis from "@/apis";
export default {
  data() {
    return {
     
        loanData:{
          totalProfile:0,
          indApp:0,
          groupApp:0,
          EducationLoan:0
      }
    };
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    signup(typ){
        this.$router.push("/signup/"+typ);
    },
    signupWorker(){
      this.$router.push("/profile")
    },
    signupemployer(){
      this.$router.push("/LoginProfile");
    },
    signupagency(){
        this.$router.push("/toliprofile");
    },
    getAppData() {
      let promise = apis.getAppData();
      promise
        .then(response => {
          if (response.status == 200 && response.body) {
            const data = response.body;

            const formatNum = (val) => {
              const n = parseInt(String(val || "0").replace(/[^\d]/g, ""), 10);
              return Number.isNaN(n) ? "0" : n.toLocaleString("en-IN");
            };

            const parseAmt = (val) => {
              const clean = String(val || "").replace(/Cr\./gi, "").replace(/[^\d.-]/g, "").trim();
              const n = parseFloat(clean);
              return Number.isNaN(n) ? 0 : n;
            };

            const indApp = parseInt(data.indApp, 10) || 0;
            const grpApp = parseInt(data.groupApp, 10) || 0;
            const eduApp = parseInt(data.EducationApp, 10) || 0;
            const totalApp = indApp + grpApp + eduApp;

            const indLoi = parseInt(data.personalLoi, 10) || 0;
            const grpLoi = parseInt(data.groupLoi, 10) || 0;
            const eduLoi = parseInt(data.EducationLoi, 10) || 0;
            const totalLoi = indLoi + grpLoi + eduLoi;

            const indAmt = parseAmt(data.personalLoiAmt);
            const grpAmt = parseAmt(data.groupLoiAmt);
            const eduAmt = parseAmt(data.EducationLoiAmt);
            const totalAmt = indAmt + grpAmt + eduAmt;

            this.loanData = {
              totalProfile: formatNum(data.totalProfile),
              totalApp: totalApp.toLocaleString("en-IN"),
              totalLoi: totalLoi.toLocaleString("en-IN"),
              totalAmt: totalAmt.toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 }),
              indApp: indApp.toLocaleString("en-IN"),
              personalLoi: indLoi.toLocaleString("en-IN"),
              personalLoiAmt: `${indAmt.toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Cr.`,
              groupApp: grpApp.toLocaleString("en-IN"),
              groupLoi: grpLoi.toLocaleString("en-IN"),
              groupLoiAmt: `${grpAmt.toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Cr.`,
              EducationApp: eduApp.toLocaleString("en-IN"),
              EducationLoi: eduLoi.toLocaleString("en-IN"),
              EducationLoiAmt: `${eduAmt.toLocaleString("en-IN", { minimumFractionDigits: 3, maximumFractionDigits: 3 })} Cr.`,
            };
          }
        })
        .catch(err => {
        });
    },
    getValues() {
      let promise = apis.getDashbord(this.newBoard);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.form = response.body[0];
          }
        })
        .catch(err => {
        });
    },
    getValuesReg() {
      let promise = apis.getDashbord(this.regBoard);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.formReg = response.body[0];
          }
        })
        .catch(err => {
        });
    }
  },
  mounted() {
      this.getAppData();
    // this.getValues();
    // this.getValuesReg();
  }
};
</script>

<style scoped>
.container{
    width:100% !important;
}


/* UI changes by Akshay 15-08-2019 */

.link-anchor{
  font-size: 13px;
  font-weight: bold;
  color:#fff;
  background-color: #2e4b90;
  padding:8px 20px;
  display: block;
  width: fit-content;
  border-radius: 4px;
}

.stats-main-wrap{
  margin-bottom:15px;
  min-width: 0;
}

.stats-heading{
  font-size: 17px;
  color:#000;
  font-weight: bold;
  margin-bottom:4px;
  text-align: center;
}

.row-2{
  margin-top:30px;
}

img.header-icon{
  width: 50px;
  margin:auto;
  display: block;
  margin-bottom:8px;
}

.stats-main-wrap .stat-box-wrap{
  display: flex;
  margin-top:10px;
  margin-bottom:10px;
  min-width: 0;
}
.stats-main-wrap .icon-box{
  background-color:#00bcd4;
  flex: 0 0 auto;
  padding:8px;
  padding-top:12px;
  padding-bottom:12px;
  border:1px solid transparent;
  border-right: none;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.stats-main-wrap .icon-box img{
  width: 40px;
  vertical-align: middle;
}

.stat-box-wrap .info-box{
  border:1px solid #d3d3d3;
  border-left:none;
  background-color:#f1f1f1;

  border-radius:3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  text-align: left;
  padding:10px;
  font-weight: bold;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 150px;
}




.stat-box-wrap .info-box h6{
  margin-bottom: 8px;
  margin-top:5px;
  font-size: 11px;
  font-weight: bold;
  color:#000;
}

.stat-box-wrap .info-box h5{
  font-size:15px;
  font-weight: bold;
  color:#000;
}


@media(max-width: 1325px){
 
  .stats-boxes-2 .stat-box-wrap .info-box{
  width:135px;
  margin-right: 5px;
}

}
@media(max-width: 1199px){
  .link-anchor{
    margin-bottom:17px;
  }
}


@media(max-width: 991px){
  .stats-boxes-2{
    display: block;
  }

  .stats-boxes-2 > .stats-main-wrap{
    width: 100%;
    max-width: 100%;
  }

  .link-anchor{
    width: fit-content;
    margin:auto;
    margin-top:20px;
    margin-bottom:30px;
  }

  .stat-box-wrap .info-box{
    width:150px;
  }

  .stats-heading{
    margin-bottom:15px;
  }

   .stat-box-wrap{
    width:fit-content;
    margin-left:auto;
    margin-right:auto;
  }
}

@media(max-width:767PX){
  .stat-box-row{
    justify-content: center;
  }

  .stat-box-row > .col{
    flex: 0 0 50%;
    max-width: 50%;
  }

  .stat-box-row > .col:empty{
    display: none;
  }

  .stats-main-wrap .stat-box-wrap{
    padding-left:5px;
    padding-right:5px;
  }

   .stats-heading{
    font-size: 15px;
  }
}

@media(max-width:419px){
  .stat-box-row > .col{
    flex-basis: 100%;
    max-width: 100%;
  }

  .link-anchor{
    width:70%;
    text-align:center;
    font-size:12px;
  }
  }


</style>



// WEBPACK FOOTER //
// src/components/Portal/StatComponent2.vue